import { Colors, INTER } from '@brg/ui';
import { LayoutConst } from 'core';
import styled from 'styled-components';

export const PredictionsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.l}px) {
    gap: 16px;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    gap: 10px;
  }
`;

export const PredictionCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 270px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: 204px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    width: 166px;
  }
`;

export const PredictionCardMeta = styled.div`
  display: none;
  flex-direction: column;

  @media (max-width: ${LayoutConst.screen.s}px) {
    display: flex;
  }
`;

export const PredictionCardMetaDate = styled.div`
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${Colors.galBlack100};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.3px;

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    margin-top: 7px;
    font-size: 13px;
    line-height: 17px;
    letter-spacing: -0.26px;
  }
`;

export const PredictionCardMetaChampion = styled.div`
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${Colors.galBlack47};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    margin-top: 3px;
    font-size: 10px;
    line-height: 12px;
  }
`;

export const PredictionCardMetaPrediction = styled.div`
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${Colors.galBlack47};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;

  span {
    font-size: 11px;
    line-height: 13px;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    margin-top: 7px;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: -0.2px;

    span {
      font-size: 10px;
      line-height: 12px;
    }
  }
`;

export const PredictionCardMetaBold = styled.span`
  font-size: 11px;
  line-height: 13px;
  font-weight: 600;

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    font-size: 10px;
    line-height: 12px;
    letter-spacing: -0.2px;
  }
`;

export const PredictionCardHoverOverlay = styled.div`
  display: none;
  position: absolute;
  inset: 0;
  z-index: 2;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(24, 26, 28, 0.00) 0.01%, rgba(24, 26, 28, 0.51) 100%);
  pointer-events: none;
`;

export const PredictionCardHoverDate = styled.div`
  color: #fff;
  ${INTER.F_17_22_Semibold};
  letter-spacing: -0.34px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    ${INTER.F_15_20_Semibold};
    letter-spacing: -0.3px;
  }
`;

export const PredictionCardHoverChampion = styled.div`
  color: #fff;
  ${INTER.F_13_16_Reg};
  letter-spacing: -0.26px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0;
  }
`;

export const PredictionCardClickIcon = styled.div`
  display: none;
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 3;
  pointer-events: none;

  svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const PredictionCard = styled.div`
  --card-padding: 8px;

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 382px;
  padding: var(--card-padding);
  box-sizing: border-box;
  background: #E6E9FF;
  gap: 4px;
  cursor: pointer;
  overflow: hidden;

  @media (min-width: ${LayoutConst.screen.s + 1}px) {
    &:hover {
      ${PredictionCardHoverOverlay} {
        display: flex;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    height: 288px;
    gap: 2px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    height: 235px;
    gap: 2px;
  }
`;

export const PredictionTopSection = styled.div`
  position: relative;
  width: 100%;
  flex: 1 1 0;
  min-height: 0;
`;

export const PredictionFlagSection = styled.div`
  width: 100%;
  flex: 1 1 0;
  min-height: 0;
`;

export const TeamFlagWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const TeamFlagImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const TeamFlagFallback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  background: #F5F5F5;
  color: #BBB;
  ${INTER.F_13_16_Semibold};
  text-align: center;
`;

export const TeamsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
  width: 100%;
`;

export const PredictionBadge = styled.div`
  position: absolute;
  top: 0;
  right: 16px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: calc(100% - 16px);
  height: 32px;
  padding: 4px 8px;
  box-sizing: border-box;
  border-radius: 4px;
  background: rgba(24, 26, 28, 0.40);
  backdrop-filter: blur(2px);
  color: ${Colors.galBlack10};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    right: 8px;
    max-width: calc(100% - 8px);
    font-size: 10px;
    font-weight: 400;
    letter-spacing: -0.2px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    display: none;
  }

  @media (min-width: ${LayoutConst.screen.s + 1}px) {
    ${PredictionCard}:hover & {
      display: none;
    }
  }
`;

export const TeamRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`;

export const TeamName = styled.div`
  flex: 1;
  min-width: 0;
  color: ${Colors.galBlack73};
  ${INTER.F_15_20_Semibold};
  letter-spacing: -0.3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    letter-spacing: 0;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    letter-spacing: -0.4px;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    font-size: 10px;
    line-height: 13px;
    letter-spacing: -0.2px;
  }
`;

export const TeamScore = styled.div`
  flex-shrink: 0;
  color: ${Colors.galBlack100};
  text-align: right;
  ${INTER.F_20_25_Semibold};
  letter-spacing: -0.4px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;  
    line-height: 16px;
    font-weight: 600;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    letter-spacing: 0;
  }
`;
import { Colors, INTER } from '@brg/ui';
import { LayoutConst } from 'core';
import styled from 'styled-components';

export const PredictionsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.l}px) {
    gap: 16px;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    gap: 10px;
  }
`;

export const PredictionCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 270px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: 204px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    width: 166px;
  }
`;

export const PredictionCardMeta = styled.div`
  display: none;
  flex-direction: column;

  @media (max-width: ${LayoutConst.screen.s}px) {
    display: flex;
  }
`;

export const PredictionCardMetaDate = styled.div`
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${Colors.galBlack100};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.3px;

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    margin-top: 7px;
    font-size: 13px;
    line-height: 17px;
    letter-spacing: -0.26px;
  }
`;

export const PredictionCardMetaChampion = styled.div`
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${Colors.galBlack47};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    margin-top: 3px;
    font-size: 10px;
    line-height: 12px;
  }
`;

export const PredictionCardMetaPrediction = styled.div`
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${Colors.galBlack47};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;

  span {
    font-size: 11px;
    line-height: 13px;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    margin-top: 7px;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: -0.2px;

    span {
      font-size: 10px;
      line-height: 12px;
    }
  }
`;

export const PredictionCardMetaBold = styled.span`
  font-size: 11px;
  line-height: 13px;
  font-weight: 600;

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    font-size: 10px;
    line-height: 12px;
    letter-spacing: -0.2px;
  }
`;

export const PredictionCardHoverOverlay = styled.div`
  display: none;
  position: absolute;
  inset: 0;
  z-index: 2;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(24, 26, 28, 0.00) 0.01%, rgba(24, 26, 28, 0.51) 100%);
  pointer-events: none;
`;

export const PredictionCardHoverDate = styled.div`
  color: #fff;
  ${INTER.F_17_22_Semibold};
  letter-spacing: -0.34px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    ${INTER.F_15_20_Semibold};
    letter-spacing: -0.3px;
  }
`;

export const PredictionCardHoverChampion = styled.div`
  color: #fff;
  ${INTER.F_13_16_Reg};
  letter-spacing: -0.26px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0;
  }
`;

export const PredictionCardClickIcon = styled.div`
  display: none;
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 3;
  pointer-events: none;

  svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const PredictionCard = styled.div`
  --card-padding: 8px;

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 382px;
  padding: var(--card-padding);
  box-sizing: border-box;
  background: #E6E9FF;
  gap: 4px;
  cursor: pointer;
  overflow: hidden;

  @media (min-width: ${LayoutConst.screen.s + 1}px) {
    &:hover {
      ${PredictionCardHoverOverlay} {
        display: flex;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    height: 288px;
    gap: 2px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    height: 235px;
    gap: 2px;
  }
`;

export const PredictionTopSection = styled.div`
  position: relative;
  width: 100%;
  flex: 1 1 0;
  min-height: 0;
`;

export const PredictionFlagSection = styled.div`
  width: 100%;
  flex: 1 1 0;
  min-height: 0;
`;

export const TeamFlagWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const TeamFlagImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const TeamFlagFallback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  background: #F5F5F5;
  color: #BBB;
  ${INTER.F_13_16_Semibold};
  text-align: center;
`;

export const TeamsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
  width: 100%;
`;

export const PredictionBadge = styled.div`
  position: absolute;
  top: 0;
  right: 16px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: calc(100% - 16px);
  height: 32px;
  padding: 4px 8px;
  box-sizing: border-box;
  border-radius: 4px;
  background: rgba(24, 26, 28, 0.40);
  backdrop-filter: blur(2px);
  color: ${Colors.galBlack10};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    right: 8px;
    max-width: calc(100% - 8px);
    font-size: 10px;
    font-weight: 400;
    letter-spacing: -0.2px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    display: none;
  }

  @media (min-width: ${LayoutConst.screen.s + 1}px) {
    ${PredictionCard}:hover & {
      display: none;
    }
  }
`;

export const TeamRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`;

export const TeamName = styled.div`
  flex: 1;
  min-width: 0;
  color: ${Colors.galBlack73};
  ${INTER.F_15_20_Semibold};
  letter-spacing: -0.3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    letter-spacing: 0;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    letter-spacing: -0.4px;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    font-size: 10px;
    line-height: 13px;
    letter-spacing: -0.2px;
  }
`;

export const TeamScore = styled.div`
  flex-shrink: 0;
  color: ${Colors.galBlack100};
  text-align: right;
  ${INTER.F_20_25_Semibold};
  letter-spacing: -0.4px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;  
    line-height: 16px;
    font-weight: 600;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    letter-spacing: 0;
  }
`;
